import { useTheme } from '@mui/material/styles';
import { Table, TableName } from '@openx/components-table/Table';
import { useDealContext } from '../../../../../utils/context/DealContext';
import { useDealInsightsContext } from '../../../../context/DealInsightsContext';
import { NoDataComponent } from '../../../shared/NoDataComponent';
import { useGeneralDataTableColumns } from './hooks/useGeneralDataTableColumns';
import { useGeneralDataTableData } from './hooks/useGeneralDataTableData';

export const GeneralDataTable = () => {
  const { dealInsights, criteria, handleCriteriaChange } = useDealInsightsContext();
  const { useDealHealthScoreRootCauseDetails } = useDealContext();
  const { data: rawData } = dealInsights;
  const theme = useTheme();
  const { getDealRootCauseDetails, loadDealRootCauseDetails, reloadDealRootCauseDetails } =
    useDealHealthScoreRootCauseDetails();
  const { data, isLoading } = useGeneralDataTableData({ getDealRootCauseDetails });

  const { columns } = useGeneralDataTableColumns(
    {
      impressions: {
        max: rawData?.deal_stats.impressions_range.maximum ?? 0,
        min: rawData?.deal_stats.impressions_range.minimum ?? 0,
        color: theme.palette.charts.indigo,
      },
      spend: {
        max: rawData?.deal_stats.spend_range.maximum ?? 0,
        min: rawData?.deal_stats.spend_range.minimum ?? 0,
        color: theme.palette.charts.lightBlue,
      },
      ecpm: {
        max: rawData?.deal_stats.ecpm_range.maximum ?? 0,
        min: rawData?.deal_stats.ecpm_range.minimum ?? 0,
        color: theme.palette.charts.blue,
      },
      bid_rate: {
        max: 1,
        min: 0,
        color: theme.palette.charts.purple,
      },
      win_rate: {
        max: 1,
        min: 0,
        color: theme.palette.charts.magenta,
      },
      viewability: {
        max: 1,
        min: 0,
        color: theme.palette.charts.pink,
      },
      vcr: {
        max: 1,
        min: 0,
        color: theme.palette.charts.peach,
      },
      ctr: {
        max: rawData?.deal_stats.ctr_range.maximum ? rawData.deal_stats.ctr_range.maximum : 0,
        min: rawData?.deal_stats.ctr_range.minimum ? rawData.deal_stats.ctr_range.minimum : 0,
        color: theme.palette.charts.canary,
      },
      iqs_on_impression: {
        max: 100,
        min: 0,
        color: theme.palette.charts.tomato,
      },
    },
    {
      onLoadRootCause: dealId => loadDealRootCauseDetails(dealId),
      onReloadRootCause: dealId => reloadDealRootCauseDetails(dealId),
      showCurrentState: true,
    }
  );

  return (
    <Table
      data-test="general-data-table"
      data={data}
      columns={columns}
      loading={isLoading}
      criteria={criteria[TableName.DEAL_INSIGHTS_GENERAL]}
      name={TableName.DEAL_INSIGHTS_GENERAL}
      onCriteriaChange={newCriteria => handleCriteriaChange(newCriteria, TableName.DEAL_INSIGHTS_GENERAL)}
      overrideTableCellStyles={{ padding: 0 }}
      skeletonRows={10}
      customNoDataComponent={NoDataComponent}
      stickyActionColumn
    />
  );
};
